
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewards",
      function () {
        return require("private-next-pages/rewards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewards"])
      });
    }
  